import { cards } from '@constants/cards'

// Returns card object depending on first number of credit card
export const getCard = (cardNumber: string) =>
  cards.find(({ prefixNumber }) => prefixNumber.test(cardNumber))
